const IMAGES = {
  OneRoadOne: require("./OneRoadToFreedomOne.png"),
  OneRoadTwo: require("./OneRoadToFreedomTwo.png"),
  OneRoadThree: require("./OneRoadToFreedomThree.png"),
  OneRoadFour: require("./OneRoadToFreedomFour.png"),
  OneRoadFive: require("./OneRoadToFreedomFive.png"),

  WeatherAppOne: require("./WeatherAppOne.png"),
  WeatherAppTwo: require("./WeatherAppTwo.png"),
  WeatherAppThree: require("./WeatherAppThree.png"),

  TravelBlogOne: require("./TravelBlogOne.png"),
  TravelBlogTwo: require("./TravelBlogTwo.png"),
  TravelBlogThree: require("./TravelBlogThree.png"),
  TravelBlogFour: require("./TravelBlogFour.png"),
  TravelBlogFive: require("./TravelBlogFive.png"),

  PinkDictionaryOne: require("./PinkDictionaryAppOne.png"),
  PinkDictionaryTwo: require("./PinkDictionaryAppTwo.png"),

  Coding: require("./codingOne.jpg"),
};

export default IMAGES;
